export const TAGS_QUERY = '/tags';
